module.exports = __webpack_public_path__ + "static/media/bc15b3ca-523b-46bf-baa5-152b4d332ead_1.8ea32ea712ce2eb064e401952d79f886.4fb11c3a.jpeg";